<app-pageheader [Parent]="this">
  <add-button AddRoute="/parking/accesscontrol/customgroups/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="infrastructure/customgroups/searches"
[AllowEdit]="true" EditUrl="/parking/accesscontrol/customgroups/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview>